var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 16.7786C14.8085 16.7786 16.3802 16.7786 17.356 15.802C18.3327 14.8261 18.3327 13.2545 18.3327 10.112C18.3327 6.96948 18.3327 5.39781 17.356 4.42198C16.3802 3.44531 14.8085 3.44531 11.666 3.44531H8.33268C5.19018 3.44531 3.61852 3.44531 2.64268 4.42198C1.66602 5.39781 1.66602 6.96948 1.66602 10.112C1.66602 13.2545 1.66602 14.8261 2.64268 15.802C3.18685 16.347 3.91602 16.5878 4.99935 16.6936",
    stroke: "#1C66F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 8.01499C8.75065 7.18999 9.16732 6.77832 10.0007 6.77832C11.039 6.77832 11.6673 7.60249 11.6673 8.42665C11.6673 9.25082 11.2507 9.28749 10.0007 10.1117V10.945M10.0007 13.0283V13.445",
    stroke: "#1C66F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6664 16.7783C10.6364 16.7783 9.50138 17.195 8.46555 17.7325C6.80055 18.5967 5.96805 19.0292 5.55805 18.7533C5.14805 18.4783 5.22555 17.6242 5.38138 15.9167L5.41638 15.5283",
    stroke: "#1C66F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.16e953aa275b41f3a737d78aff80ebf3.svg";
export { ForwardRef as ReactComponent };